module.exports = __webpack_public_path__ + "static/media/euro_sign.50983052.svg";